import { Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { TFunction } from "next-i18next";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { Router } from "../../i18n";
import { HotelDataDto, SelectedHotelDto } from "../libs/hotel";
import numberSeparator from "../utils/numberSeparator";

type CartType = {
  totalQty: number;
  totalPrice: number;
  hotel: string;
  food?: boolean;
  readonly t: TFunction;
  souvenir?: boolean;
};

const Cart = (props: CartType) => {
  const { totalQty, totalPrice, hotel, food, t, souvenir } = props;
  const classes = useStyles(props);
  const router = useRouter();
  const { asPath } = useRouter();
  const [existingHotel, setExistingHotel] = useState<SelectedHotelDto>(Object);
  const hotel_username = router.query.hotel_username;
  const artotelSpecial = process.env.ARTOTEL_SPECIAL?.split(",");
  const [hotel_data, setHotelData] = useState<HotelDataDto>(Object);

  useEffect(() => {
    setHotelData(JSON.parse(localStorage.getItem("hotel_data") || "{}"));
  }, []);

  useEffect(() => {
    if (asPath.includes("/hotels/foods/search-location")) {
      const hotel = JSON.parse(localStorage.getItem("hotel") || "{}");
      setExistingHotel(hotel);
    }
    if (asPath.includes("/hotels/souvenirs/search-location")) {
      const hotel = JSON.parse(localStorage.getItem("souvenirHotel") || "{}");
      setExistingHotel(hotel);
    }
  }, []);

  const handlePesan = () => {
    const isLogged = localStorage.getItem("token") ? true : false;
    if (
      isLogged ||
      artotelSpecial?.findIndex((id) => id === hotel_data?.hotelId) !== -1
    ) {
      if (souvenir) {
        Router.push(
          `/hotels/${hotel_username || existingHotel?.username}/souvenirs/order`
        );
        return;
      }
      if (food) {
        Router.push(
          `/hotels/${
            hotel_username || existingHotel?.username
          }/foods/order?type=inhotel`
        );
        return;
      } else {
        Router.push(`/hotels/rooms/orders`);
      }
    } else {
      if (souvenir) {
        localStorage.setItem(`from`, asPath);
        Router.push(
          `/login?redirect=/hotels/${
            hotel_username || existingHotel?.username
          }/souvenirs/order`
        );
        return;
      }
      if (food) {
        localStorage.setItem(`from`, asPath);
        Router.push(
          `/login?redirect=/hotels/${
            hotel_username || existingHotel?.username
          }/foods/order?type=inhotel`
        );
        return;
      } else {
        localStorage.setItem(`from`, asPath);
        Router.push(`/login?redirect=/hotels/rooms/orders`);
        return;
      }
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.container} onClick={handlePesan}>
        <div>
          <div>
            <Typography variant="body2" className={classes.text1}>
              {totalQty}{" "}
              {food
                ? totalQty > 1
                  ? t("foods")
                  : t("food")
                : souvenir
                ? totalQty > 1
                  ? t("souvenirs")
                  : t("souvenir")
                : totalQty > 1
                ? t("Rooms")
                : t("Room")}
              {""} | Rp
              {numberSeparator(totalPrice)}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" className={classes.text2}>
              {hotel}
            </Typography>
          </div>
        </div>
        <div>
          <Typography className={classes.text3}>{t("order")}</Typography>
        </div>
      </div>
    </div>
  );
};

export default Cart;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "fixed",
      bottom: 0,
      width: "100%",
      maxWidth: 444,
      background:
        "linear-gradient(180.39deg, rgba(255, 255, 255, 0) 1.54%, #FFFFFF 70%)",
    },
    container: {
      margin: 16,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#9e007e",
      padding: "8px 16px",
      boxShadow: "0px 10px 15px rgba(51, 131, 225, 0.2)",
      cursor: "pointer",
    },
    text1: {
      fontWeight: "bold",
      color: "#ffffff",
    },
    text2: {
      color: "#ffffff",
    },
    text3: {
      fontWeight: "bold",
      color: "#ffffff",
      cursor: "pointer",
    },
  })
);
